import auth from "./authReducer";
import apps from "./appsReducer";
import appStyle from "./appStyleReducer";
import module from "./moduleReducer";
import moduleType from "./moduleTypeReducer";
import screen from "./screenReducer";
import styles from "./stylesReducer";
import formRules from "./formRulesReducer";
import tabsAndForms from "./tabsAndFormsReducer";
import coreComponent from "./coreComponentReducer";
import actions from "./actionReducer";
import fieldNames from "./fieldNamesReducer";
import items from "./itemsReducer";
import filter from "./filterReducer";
import categories from "./categoriesReducer";
import categoryValues from "./categoryValuesReducer";
import tags from "./tagsReducer";
import industries from "./industriesReducer";
import packages from "./packagesReducer";
import languages from "./languagesReducer";
import appRules from "./appRulesReducer";
import googleForms from "./googleFormsReducer";
import rules from "./rulesReducer";
import entities from "./entitiesReducer";
import statistics from "./statisticsReducer";
import appTheme from "./appThemeReducer";
import appTypes from "./appTypesReducer";
import appType from "./appTypeReducer";
import allAction from "./allActionReducer";
import coreLayout from "./coreLayoutReducer";
import design from "./designReducer";
import menu from "./menuReducer";
import defaults from "./defaultReducer";
import templateApps from "./templateAppsReducer";
import componentCategories from "./componentCategoriesReducer";
import buttons from "./buttonsReducer";
import payment from "./paymentReducer";
import recommend from "./recommendReducer";
import webSlider from "./webSliderReducer";
import colorPalette from "./colorPaletteReducer";
import objective from "./objectiveReducer";
import appSystem from "./appSystemReducer";
import appsTypes from "./appsTypesReducer";
import systemLocalizations from "./systemLocalizationsReducer";
import entityLocalizations from "./entityLocalizationsReducer";
import fileFieldsAr from "./fileFieldsArReducer";
import fileFieldsEn from "./fileFieldsEnReducer";
import template from "./templateReducer";
import sheet from "./sheetReducer";

export {
  sheet,
  template,
  fileFieldsEn,
  fileFieldsAr,
  systemLocalizations,
  entityLocalizations,
  appsTypes,
  appSystem,
  colorPalette,
  objective,
  webSlider,
  recommend,
  payment,
  buttons,
  componentCategories,
  defaults,
  design,
  coreLayout,
  allAction,
  appType,
  filter,
  auth,
  apps,
  appStyle,
  module,
  screen,
  styles,
  moduleType,
  formRules,
  tabsAndForms,
  coreComponent,
  actions,
  fieldNames,
  items,
  categories,
  categoryValues,
  tags,
  industries,
  packages,
  languages,
  appRules,
  googleForms,
  rules,
  entities,
  statistics,
  appTheme,
  appTypes,
  menu,
  templateApps,
};
